import React, { ReactNode } from 'react';

import { cn } from '@portal/utils';

export const TypographyUI = ({
  variant = 'body',
  color,
  className,
  children,
}: {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle' | 'body' | 'caption';
  color?: string;
  className?: string;
  children: ReactNode;
}) => {
  let baseClasses = 'antialiased tracking-normal font-sans text-inherit';
  if (variant === 'h1') baseClasses += ' text-5xl font-semibold leading-tight';
  if (variant === 'h2') baseClasses += ' text-4xl font-semibold leading-[1.3]';
  if (variant === 'h3') baseClasses += ' text-3xl font-semibold leading-snug';
  if (variant === 'h4') baseClasses += ' text-2xl font-semibold leading-snug';
  if (variant === 'h5') baseClasses += ' text-xl font-semibold leading-snug';
  if (variant === 'h6') baseClasses += ' text-base font-semibold leading-relaxed';
  if (variant === 'subtitle') baseClasses += ' text-xl font-normal leading-relaxed';
  if (variant === 'body') baseClasses += ' text-base font-light leading-relaxed';
  if (variant === 'caption') baseClasses += ' text-sm font-light leading-normal';

  if (variant === 'h1') return <h1 className={cn(baseClasses, color, className)}>{children}</h1>;
  if (variant === 'h2') return <h2 className={cn(baseClasses, color, className)}>{children}</h2>;
  if (variant === 'h3') return <h3 className={cn(baseClasses, color, className)}>{children}</h3>;
  if (variant === 'h4') return <h4 className={cn(baseClasses, color, className)}>{children}</h4>;
  if (variant === 'h5') return <h5 className={cn(baseClasses, color, className)}>{children}</h5>;
  if (variant === 'h6') return <h6 className={cn(baseClasses, color, className)}>{children}</h6>;
  return <p className={cn(baseClasses, color, className)}>{children}</p>;
};
